import { useQuery } from "@apollo/client";

import { GqlPlannerV2VisitGetAllParams } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";

import { ProjectVisitListScreen_GetAllDocument } from "../queries.generated";

type UseProjectVisitListScreen_GetAllParams = {
    clientId: string;
    projectId: string;
    params: GqlPlannerV2VisitGetAllParams;
};

export function useProjectVisitListScreen_GetAll({ clientId, projectId, params }: UseProjectVisitListScreen_GetAllParams) {
    const { data, loading, error } = useQuery(ProjectVisitListScreen_GetAllDocument, {
        variables: {
            clientId: clientId,
            projectId: projectId,
            params: params,
        },
        fetchPolicy: "cache-and-network",
    });

    const queryInfo = data?.plannerV2VisitGetAll.queryInfo;
    const [, total] = useCacheFilterOptions(null, queryInfo?.paginationOption.total);

    return {
        loading,
        error,
        total: total,
        data: data?.plannerV2VisitGetAll.data,
    };
}
